import { Size } from '@ff-os/shared-utils/types/Size';
import { areSameOrientation } from './areSameOrientation';
import { PhotoPrintsJson } from './PhotoPrintsJson';

// To display a landscape image inside a portrait photo-print or vice versa,
// the image/scene is rotated. The rotation differs depending on the PaintTarget:
// - During preview/thumbnail the image is upright, but scene is rotated around it
// - During print the image is rotated, but scene remains upright
export type RotationSettings = {
    rotateImage: boolean;
    rotateScene: boolean;
    imageOrientation: 0 | 90;
};

export const getRotationSettings = (
    size: Size,
    photo: PhotoPrintsJson.ProcessedPhoto
): RotationSettings => {

    const sameOrientation = areSameOrientation(size, photo.crop);

    return {
        rotateImage: !sameOrientation,
        rotateScene: !sameOrientation,
        imageOrientation: 0
    };
};